import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './Spinner.module.css';
export type SpinnerProps = PropsWithoutChildren<ComponentProps<'div'>>;
export const Spinner: FunctionComponent<SpinnerProps> = React.memo(props => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      className,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true
    });
    t0 = remainingProps;
    t1 = classes(className, styles.container);
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg className={styles.svg} viewBox="25 25 50 50"><circle className={styles.circle} cx="50" cy="50" r="20" vectorEffect="non-scaling-stroke" /></svg>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1) {
    t3 = <div {...t0} className={t1}>{t2}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
});